export default __webpack_public_path__ + "static/media/tb-icon.d97c6f4a.png";